import React, { useState } from "react";
import ReactDom from "react-dom";
import styles from "./modal.module.scss";

export default function FileReaderModal({ path, type, handleClose }) {

    return ReactDom.createPortal(
        <div className={styles.modal} >
            <div className={styles.outside} onClick={handleClose}>

            </div>
            {(type === 'video') ? <div className={styles.video}>
                <video width="auto" height="60vh" autoPlay={true} loop={true} controls>
                    <source src={path} type="video/mp4" />
                </video>

            </div> :
                <div className={styles.audio}>

                    <audio controls>
                        <source src={path} type="audio/mp3" />
                    </audio>
                </div>
            }

        </div>,
        document.getElementById('video_portal')
    )
}